import { ref } from 'vue';
import type { OverviewTaskItem } from './useOverviewTaskParser';
import { useLoadingSpinnerStore } from '@/stores/loadingSpinner';
import { toast } from 'vue-sonner';
import { Api } from '@/api';

export const useTaskList = (contactId: string) => {
  const loadingSpinnerStore = useLoadingSpinnerStore();
  const deleteTaskCandidate = ref<OverviewTaskItem | null>(null);
  const completeTaskCandidate = ref<OverviewTaskItem | null>(null);

  const deleteUserTask = async () => {
    const userTaskId = deleteTaskCandidate.value?.userTaskId;
    if (!userTaskId) return;

    const response = await Api.Contacts.deleteContactTask({ contactId, userTaskId });
    loadingSpinnerStore.hideLocalLoadingSpinner();

    if (response.status === 'success') {
      hideDeleteModal();
      const description = 'This task was successfully deleted.';
      toast.success('Task Deleted', { description });
      return true;
    } else {
      const description = response.messages.join(', ');
      toast.error('Failed to delete task', { description });
      return false;
    }
  };

  const completeUserTask = async () => {
    const userTaskId = completeTaskCandidate.value?.userTaskId;
    if (!userTaskId) return false;

    const response = await Api.Contacts.updateContactTask({
      contactId,
      userTaskId,
      payload: { user_task: { status: 'completed' } },
    });
    loadingSpinnerStore.hideLocalLoadingSpinner();

    if (response.status === 'success') {
      hideCompleteModal();
      toast.success('Task completed');
      return true;
    } else {
      const description = response.messages.join(', ');
      toast.error('Failed to complete task', { description });
      return false;
    }
  };

  const hideDeleteModal = () => (deleteTaskCandidate.value = null);
  const displayDeleteModal = (task: OverviewTaskItem) => (deleteTaskCandidate.value = task);

  const hideCompleteModal = () => (completeTaskCandidate.value = null);
  const displayCompleteModal = (task: OverviewTaskItem) => (completeTaskCandidate.value = task);

  return {
    deleteTaskCandidate,
    completeTaskCandidate,
    deleteUserTask,
    completeUserTask,
    displayDeleteModal,
    hideDeleteModal,
    displayCompleteModal,
    hideCompleteModal,
  };
};
